import { useMiniKit } from '@coinbase/onchainkit/minikit'
import { useQuery } from '@tanstack/react-query'
import { CatchBoundary, Outlet, useLocation } from '@tanstack/react-router'
import { Suspense } from 'react'

import { MiniappAppLayout } from './MiniappAppLayout'
import { ComplianceContainer } from '@/features/compliance/ComplianceContainer'
import { Debug } from '@/features/debug'
import { DialogDispatcherContainer } from '@/features/dialogs/dispatcher/DialogDispatcherContainer'
import { ErrorComponent } from '@/features/errors/ErrorComponent'
import { FallbackLayout } from '@/ui/layouts/FallbackLayout'

export function MiniappRootRoute() {
  const location = useLocation()
  const { setFrameReady, isFrameReady } = useMiniKit()
  useQuery({
    queryKey: ['minikit-frame-ready'],
    queryFn: async () => setFrameReady(),
    enabled: !isFrameReady,
  })
  return (
    <Suspense fallback={<FallbackLayout />}>
      <MiniappAppLayout>
        <CatchBoundary getResetKey={() => location.href} errorComponent={ErrorComponent}>
          <Outlet />
          <DialogDispatcherContainer />
          <ComplianceContainer />
        </CatchBoundary>
        {import.meta.env.VITE_DEV_DEBUG === '1' && <Debug />}
      </MiniappAppLayout>
    </Suspense>
  )
}
